module.exports = __webpack_public_path__ + "img/terrace.1523113a.jpeg";